import {ApiModel} from '@models/api-model';
import {WizardInterfaces} from '../../../wizard.namespace';
import {WizardCardPreview} from './equipment-item-preview/wizard-card-preview';

export class EquipmentGroupPreview extends ApiModel<WizardInterfaces.ApparatusStepGroup> {
    public title: string;
    public required: boolean;
    public valid: boolean;
    public errorMessage: string;
    public equipment: WizardCardPreview[];

    constructor(
        _rawData: WizardInterfaces.ApparatusStepGroup
    ) {
        super(_rawData);
        this.setAttributes();
    }

    protected setAttributes() {
        this.title = this.rawData.title;
        this.required = this.rawData.required;
        this.valid = this.rawData.valid;
        this.errorMessage = this.rawData.error_message;
        this.equipment = this.rawData.equipment.map(item => new WizardCardPreview(item));
    }
}
